export function normalizeInvoiceReferenceCode(code: string) {
  return normalizeLookupCode(code);
}

export function normalizeCustomerAccountCode(code: string) {
  return normalizeLookupCode(code);
}

function normalizeLookupCode(code: string) {
  return code.trim().toUpperCase();
}
